export type Jsonifiable = Parameters<(typeof JSON)['stringify']>[0];

export abstract class SessionStorageBase {
  protected getKey(baseKey: string, accountId?: number) {
    return accountId ? `${baseKey}-${accountId}` : baseKey;
  }

  protected save(key: string, value: Jsonifiable) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  protected load(key: string): null | Jsonifiable {
    const serializedValue = sessionStorage.getItem(key);

    if (!serializedValue) return null;

    return JSON.parse(serializedValue);
  }

  protected clear(key: string) {
    sessionStorage.removeItem(key);
  }
}
